import { Box, Button, Fab, Fade, Popper, makeStyles } from "@material-ui/core"
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import PrintIcon from '@material-ui/icons/Print';
import download from "downloadjs";
import useKitsPrintout from "./KitsPrintout";
import Http from "../../engine/Http";
import { useState } from "react";
import clsx from "clsx";
import useCustomerApi from "../../api/CustomerApi.hook";

interface Props {
  readonly customerId: number;
  readonly priceListId: number;
  kitIds: number[];
  buttonClasses: ClassNameMap;
}

const useStyles = makeStyles(theme => ({
  popper: {
    zIndex: 200
  }, 
  popperContent: {
    display: 'flex',
    flexDirection: 'column'
  }, 
  button: {
    marginTop: theme.spacing(1)
  },
  rotate: {
    animation: "$spin 1s linear infinite"
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  }
}));

const KitsPrintoutButton = (props: Props) => {
  const classes = useStyles();
  const kitsPrintout = useKitsPrintout();
  const customerApi = useCustomerApi();
  const customerId = props.customerId;
  const priceListId = props.priceListId;
  const kitIds = props.kitIds;
  const [isPopperOpen, setPopperOpen] = useState<boolean>(false);
  const [anchorElement, setAnchorElement] = useState<HTMLElement|null>(null);
  const [isInProgress, setInProgress] = useState<boolean>(false);

  const handlePrintKitsButtonClicked = async (mode: string) => {
    setInProgress(true);
    closePrintoutPopper();
    const kits = await kitsPrintout.getKitsForPrintout(customerId, priceListId, kitIds);
    const customer = await customerApi.fetchCustomer(customerId);
    const customerName = customer.name;
    const printout = {
      mode,
      customer: customerName,
      kits
    };
    Http
      .postForFile('/api/printouts/kits', printout)
      .then(response => response.blob())
      .then(blob => download(blob, `komplety - ${customerName}.pdf`))
      .finally(() => setInProgress(false));
  };

  const handleOpenPrintoutPopperClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isPopperOpen === true) {
      closePrintoutPopper();
    } else {
      setAnchorElement(event.currentTarget);
      setPopperOpen(true);
    }
  };

  const handleCancelPrintoutClicked = () => closePrintoutPopper();

  const closePrintoutPopper = () => {
    setPopperOpen(false);
    setAnchorElement(null);
  };

  return <>
    <Fab
      aria-label="print"
      className={ props.buttonClasses.button }
      color="primary"
      disabled={kitIds.length < 1}
      size="medium"
      onClick={ handleOpenPrintoutPopperClick }
    >
      <PrintIcon className={ clsx({ [classes.rotate]: isInProgress }) }/>
    </Fab>
    <Popper open={ isPopperOpen } anchorEl={ anchorElement } placement='top-start' transition className={ classes.popper } >
      {({ TransitionProps }) => (
        <Fade { ...TransitionProps } timeout={ 500 }>
          <Box className={ classes.popperContent }>
            <Button
              color='primary'
              className={ classes.button }
              onClick={() => handlePrintKitsButtonClicked('kits|packages')}
              variant='contained'>
                Drukuj komplety i specyfikację pakowania
            </Button>
            <Button
              color='primary'
              className={ classes.button }
              onClick={() => handlePrintKitsButtonClicked('kits')}
              variant='contained'>
                Drukuj tylko specyfikację kompletów
            </Button>
            <Button
              color='primary'
              className={ classes.button }
              onClick={() => handlePrintKitsButtonClicked('packages')}
              variant='contained'>
                Drukuj tylko specyfikację pakowania
            </Button>
            <Button
              color='secondary'
              className={ classes.button }
              onClick={ () => handleCancelPrintoutClicked() }
              variant='contained'>
                Nic nie drukuj
            </Button>
          </Box>
        </Fade>
      )}
    </Popper>
  </>;
}

export default KitsPrintoutButton;